import { appLocale } from 'shared';

import { citizenshipConfig } from '../config';

const isMatchingCountry = (query: string, name: string) => {
  return name.toLocaleLowerCase().startsWith(query.toLocaleLowerCase());
};

export const getMatchingCountries = (
  query: string,
  locale: appLocale.config.Locale,
  countryCodes?: string[],
) => {
  const list = countryCodes
    ? citizenshipConfig.countryList.filter(country =>
        countryCodes.includes(country.code),
      )
    : citizenshipConfig.countryList;

  if (query) {
    return list.filter(country => {
      const { name, nameKK, nameEN } = country;
      if (locale === appLocale.config.locales.KK) {
        return isMatchingCountry(query, nameKK);
      }
      if (locale === appLocale.config.locales.EN) {
        return isMatchingCountry(query, nameEN);
      }
      return isMatchingCountry(query, name);
    });
  }

  return citizenshipConfig.countryList;
};
